import { Component, EventEmitter, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { AbstractDynamicReportViewComponent } from '../../abstract/abstract-dynamic-report-view.component';
import { ReportInfo, ReportRecord } from '../../models/report.model';
import { groupByProperty } from '../../shared/utils/group-by-property';
import { EditableFieldsService } from '../editable-fields.service';
import { digger } from '@cbre/digger';
import { LocaleId } from '../../models/locale.model';
import { contactsSectionRequiredCountries } from '../../shared/constants/template.const';

@Component({
  selector: 'rep-presentation-view',
  templateUrl: './presentation-view.component.html',
  styleUrls: ['./presentation-view.component.scss'],
  providers: [EditableFieldsService],
  standalone: false,
})
export class PresentationViewComponent extends AbstractDynamicReportViewComponent implements OnInit, OnChanges {
  recordNumber: number;
  recordsCount: number;
  reportRecordsData: ReportInfo;
  isContactsVisible = false;

  @Output() removeRecord: EventEmitter<ReportRecord> = new EventEmitter<ReportRecord>();
  @Output() reportReordered: EventEmitter<ReportRecord[]> = new EventEmitter<ReportRecord[]>();

  ngOnChanges({ columns, currentView, reportLocale, reportData }: SimpleChanges) {
    super.ngOnChanges({ columns, currentView, reportLocale, reportData });
    // Added the view ID condition because when the report is created and for first time the template id information is not available.
    if (
      !!this.reportData &&
      this.reportData.records &&
      !!this.currentView &&
      this.reportData.entity === 'availability' &&
      [15, 3, 4, 43, 44].includes(this.currentView.templateId)
    ) {
      const groupRecordsByEntity = groupByProperty(this.reportData.records) as ReportRecord[];
      this.recordsCount = !!this.reportData && !!groupRecordsByEntity ? groupRecordsByEntity.length : null;
      this.reportRecordsData = { ...this.reportData, records: groupRecordsByEntity };
    } else if (!!this.currentView) {
      this.recordsCount = !!this.reportData && !!this.reportData.records ? this.reportData.records.length : null;
      this.reportRecordsData = this.reportData;
    }
    if (this.reportLocale === LocaleId.IndiaEnglish) {
      this.getStackingPlanSLide();
    }
    this.isContactsVisible =
      this.reportLocale &&
      this.currentView.templateId === 41 &&
      contactsSectionRequiredCountries.includes(this.reportLocale);
  }

  ngOnInit() {
    super.ngOnInit();
  }

  navRecordNum(recordNumber: number) {
    this.recordNumber = recordNumber;
  }

  private getStackingPlanSLide() {
    const payload = this.reportData.records.map(item => {
      return {
        availability_id: item.edpRecordId,
        property_id: digger(item.data, 'property.id'),
        floor: Math.floor(digger(item.data, 'floor_suite.floor_number')),
      };
    });
    this.reportExportViewService.getStackingPlan(payload);
  }
}
